export class Batcher {
    constructor(flusher) {
        this.flusher = flusher;
        this.batches = new Map();
        this.flush = (key) => {
            const batch = this.batches.get(key);
            if (!batch)
                return;
            return batch.flush();
        };
        this.discard = (key) => {
            const batch = this.batches.get(key);
            if (!batch)
                return;
            batch.discard();
            this.batches.delete(key);
        };
    }
    add({ key, userData, items, max, timeout, }) {
        let batch = this.batches.get(key);
        if (!batch) {
            batch = new Batch({
                max: max || null,
                startedAt: Date.now(),
                userData,
                timeout: timeout || null,
                flusher: this.flusher,
                key,
            });
            this.batches.set(key, batch);
        }
        batch.update({
            items,
            max,
            timeout,
            userData,
        });
        return batch;
    }
}
export class Batch {
    constructor({ max, startedAt, timeout, userData, flusher, key, }) {
        this.items = [];
        this.update = ({ items, max, timeout, userData, }) => {
            this.items.push(...items);
            if (max !== undefined)
                this.max = max;
            if (timeout !== undefined)
                this.timeout = timeout;
            if (userData)
                this.userData = userData;
            // if the batch has items and a timeout but has not
            // scheduled yet, schedule it
            const needsSchedule = this.items.length !== 0 && this.timeout !== null && !this.flushTimeout;
            // if the batch has already reached its max, skip scheduling
            // and flush immediately
            if (this.max !== null && this.items.length >= this.max) {
                this.flush();
            }
            else if (needsSchedule && this.timeout !== null) {
                this.flushTimeout = setTimeout(this.flush, this.timeout);
            }
        };
        this.flush = () => {
            this.flushTimeout && clearTimeout(this.flushTimeout);
            this.flushTimeout = undefined;
            const items = this.items;
            this.items = [];
            return this.flusher(items, this.key, this.userData);
        };
        this.discard = () => {
            this.flushTimeout && clearTimeout(this.flushTimeout);
            this.flushTimeout = undefined;
            this.items = [];
        };
        this.max = max;
        this.startedAt = startedAt;
        this.timeout = timeout;
        this.userData = userData;
        this.flusher = flusher;
        this.key = key;
    }
}
//# sourceMappingURL=batching.js.map